/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Strona główna',
	myContent: 'Moja treść',
	teamContent: 'Treści zespołu',
	folder: 'Folder',
	files: 'Pliki',
	actionMenu: 'Menu czynności',
	myFolder: 'Moje foldery',

	emptyFolderNoContent: 'Brak treści',

	//EmptyStates
	emptyRecentTitle: 'Ostatnio nie wyświetlano żadnej treści.',
	emptyStateTitle: 'Rozpocznij od dodania danych',
	emptyStateBody: 'Kliknij opcję Prześlij dane, znajdującą się powyżej, lub przeciągnij i upuść, aby przesłać dane.',
	emptySearchResultTitle: 'Wyszukiwanie nie zwróciło żadnych wyników.',
	emptyPortalTitle: 'Brak portali',
	emptyPortalBody: 'Obecnie nie masz żadnych portali.',
	emptyWsProjectTitle: 'Rozpocznij od utworzenia notatnika w Watson Studio.',
	emptyWsProjectBody: 'Po powrocie do Cognos Analytics Twój notatnik będzie tutaj widoczny.',
	emptyFilteredResultTitle: 'Zastosowane filtry nie zwróciły żadnych wyników.',
	emptyDialogViewTitle: 'Brak elementów',
	removeFromRecents: 'Usuń z ostatnich',

	// Welcome Banner
	welcomeBannerGreeting: 'Witamy w programie Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics stwarza użytkownikom warunki do samodzielnego prowadzenia analiz ze wsparciem sztucznej inteligencji. Zobacz, w jaki sposób techniki zautomatyzowanego przygotowywania danych, wykrywanie i wizualizacje mogą pomóc w podejmowaniu lepiej umotywowanych decyzji.',
	welcomeBannerDescription_trialUser: 'Możesz zacząć od razu, kierując się wskazówkami z naszego filmowego wprowadzenia, prezentacji produktu oraz karty Pierwsze kroki.',
	takeTourButtonLabel: 'Zobacz prezentację produktu',
	watchVideoButtonLabel: 'Obejrzyj film',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Czy na pewno chcesz wyłączyć baner powitalny na swojej stronie głównej? Możesz go w dowolnym momencie z powrotem włączyć w sekcji Profil i ustawienia > Ustawienia > Ogólne. ',
	hideWelcomeBannerTitle: 'Wyłącz baner powitalny',
	ok: 'OK',
	cancel: 'Anuluj',
	//howto video dialog
	modal_how_title: 'Instruktażowe materiały wideo',
	modal_overview_title: 'Obejrzyj przegląd programu Cognos Analytics',
	modal_how_play: 'Odtwórz wideo',
	modal_how_video_title_overview: 'Przegląd',
	modal_how_video_title_getStarted: 'Wprowadzenie do wersji 11.2',
	modal_how_video_title_newUI: 'Witamy w nowym interfejsie użytkownika Cognos',
	modal_how_video_title_dataModule: 'Przegląd modułów danych',
	modal_how_video_title_explore: 'Przegląd eksploracji danych',
	modal_how_video_title_dashboard: 'Przegląd kokpitów interaktywnych',
	modal_how_video_title_reporting: 'Przegląd raportowania',
	modal_how_video_title_mobile: 'Potęga oprogramowania Cognos — na dłoni',

	// Toolbar
	search: 'Szukaj',
	addFolder: 'Dodaj folder',
	addLink: 'Dodaj odsyłacz',
	filter: 'Filtruj',
	sort: 'Sortuj',
	settings: 'Ustawienia',
	tilesView: 'Widok kafli',
	listView: 'Widok listy',
	columnView: 'Widok kolumn',

	// Toolbar Actions
	sortBy: 'Sortuj wg',
	sortOrder: 'Porządkuj',
	name: 'Nazwa',
	modifiedTime: 'Zmodyfikowane',
	type: 'Typ',
	ascending: 'Rosnąco',
	descending: 'Malejąco',

	filterType: 'Typ',
	filterModificationTime: 'Zmodyfikowane',
	all: 'Wszystko',
	today: 'Dzisiaj',
	yesterday: 'Wczoraj',
	pastWeek: 'Poprzedni tydzień',
	pastMonth: 'Poprzedni miesiąc',
	resetFilters: 'Resetuj filtry',

	filterSearchPlaceHolder: 'Filtruj wg słów kluczowych',

	resetFilterTag: 'Kliknij przycisk X, aby zresetować filtry.',
	filterTagToolTip: 'Zastosowane filtry: %{appliedFilters}.',

	folderName: 'Nazwa folderu',
	addAFolder: 'Dodaj folder',
	add: 'Dodaj',
	error: 'Błąd',
	newFolderDefaultName: 'Nowy folder',
	toastCreateNewFolder: 'Folder %{nameOfFolder} został utworzony w %{tabName}.',
	folderAdded: 'Dodano folder',
	refresh: 'Odśwież',
	openFolder: 'Otwórz folder',

	addAUrl: 'Dodaj adres URL',
	linkName: 'Nazwa adresu URL',
	linkNamePlaceholder: 'Dodaj nazwę adresu URL',
	linkDescription: 'Opis (opcjonalny)',
	linkDescriptionPlaceholder: 'Dodaj opis',
	linkUri: 'Adres URL',
	linkUriPlaceholder: 'Dodaj adres URL z dopuszczalną domeną',
	acceptableDomains: 'Dopuszczalne domeny',
	viewAcceptableDomains: 'Wyświetl dopuszczalne domeny',
	mandatoryField: 'Pole obowiązkowe',
	linkAdded: 'Dodano adres URL',
	toastCreateNewLink: '%{nameOfLink} dodano do %{tabName}.',
	noEntries: 'Lista dopuszczalnych domen nie zawiera żadnych wpisów. Skontaktuj się z administratorem.',

	compact: 'Kompaktowy',
	short: 'Krótki',
	default: 'Domyślny',
	rowSize: 'Wielkość wiersza',

	// GroupyByTypes
	folders: 'Foldery',
	reports: 'Raporty',
	dashboards: 'Panele kontrolne',
	data: 'Dane',
	packages: 'Pakiety',
	explorations: 'Eksploracje',
	stories: 'Scenariusze',
	notebooks: 'Notatniki',
	others: 'Inne',

	// Error Messages
	itemsOverLimit: 'Długość podanej nazwy "%{itemName}" przekracza limit (20). Aby kontynuować, podaj inną nazwę.',
	errorMessageLengthFolderName: 'Wprowadź nazwę folderu nie dłuższą niż 255 znaków.',
	errorMessageLengthLinkName: 'Wprowadź nazwę odsyłacza nie dłuższą niż 255 znaków.',
	toastLaunchPerspectiveError: 'Nie można otworzyć obiektu %{objectType}.',
	errorNoAccessTitle: 'Wygląda na to, że nie masz dostępu do tej treści.',
	errorNoAccessBody: 'Skontaktuj się z administratorem lub skorzystaj z następującego odsyłacza:',
	errorEnableExternalContent: 'Włączanie treści zewnętrznej',

	//TableHeader
	lastModified: 'Data ostatniej modyfikacji',
	location: 'Lokalizacja',
	tenant: 'Podmiot użytkujący',

	// GetStartedTab
	getStartedLabel: 'Zacznij pracę w programie IBM Cognos Analytics',
	learningHowToLabel: 'Zasoby edukacyjne',
	learningHowToDescription: 'Zdobywaj wiedzę i sięgnij po pomoc społeczności, dokumentację oraz materiały wideo.',
	learningHowToActionLabel: 'Otwórz panel Nauka',
	howToVideosLabel: 'Instruktażowe materiały wideo',
	howToVideosDescription: 'Dowiedz się, jak używać programu IBM Cognos Analytics, i zacznij wydobywać cenne spostrzeżenia ze swoich danych.',
	howToVideosActionLabel: 'Obejrzyj materiały wideo',
	acceleratorCatalogLabel: 'Accelerator Catalog',
	acceleratorCatalogDescription: 'Przeglądaj stale powiększający się katalog procedur sprawdzonych w praktyce w różnych branżach, niestandardowych wizualizacji i innych przydatnych treści.',
	acceleratorCatalogActionLabel: 'Przeglądaj katalog',
	sampleSectionTitle: 'Przykłady',
	sampleSectionDescription: 'Eksperymentuj z przykładami, które ilustrują bogactwo możliwości Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Jak utworzyć pierwszy kokpit',
	createDashboardSampleDescription: 'Rozpocznij swoją podróż analityczną od kokpitów Cognos.',
	covid19SampleTitle: 'Kokpit COVID',
	covid19SampleDescription: 'Zapoznaj się z dostępnymi możliwościami na przykładzie kokpitu Cognos, który służy do analizy danych dotyczących COVID-19, a także rozszerzeń niestandardowych.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Rozbuduj własną bibliotekę wizualizacji o mniej typowe wizualizacje, takie jak wykres Sankeya.',
	viewAllSamplesActionLabel: 'Wyświetl wszystkie przykłady',
	byFeatureTitle: 'Wg funkcji',
	byFeatureDescription: 'Przeglądaj przykłady wg funkcji, takich jak funkcje podstawowe, niestandardowe elementy sterujące, rozszerzenia, notatniki i daty względne.',
	byIndustryTitle: 'Wg branży',
	byIndustryDescription: 'Przeglądaj przykłady wg branży, takiej jak motoryzacja, bankowość itd.',
	// SamplesTab
	sampleTabTitle: 'Nasze przykłady dostarczą Ci inspiracji',
	sampleTabLabel: 'W serwisie Accelerator Catalog znajdziesz więcej przykładów i rozszerzeń opracowanych przez IBM, partnerów i klientów',

	// quickLaunch
	quickLaunchLabel: 'Szybkie uruchamianie',
	expand: 'Rozwiń',
	collapse: 'Zwiń',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Najpierw wybierz, co chcesz utworzyć.',

	// contentPageView
	contentPageTitleLabel: 'Treść',
	uploadFile: 'Prześlij dane',
	new: 'Nowe',
	create: 'Utwórz',
	more: 'Więcej',

	// open dialog
	selectDataSourcesToAdd: 'Wybierz źródła danych do dodania.',
	openDialogDefaultTitle: 'Otwórz',

	// save dialog
	save: 'Zapisz',
	saveAs: 'Zapisz jako',
	saving: 'Zapisywanie...',
	selectedDestination: 'Wybrane miejsce docelowe: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' już istnieje z innym typem. Wybierz inną nazwę.',
	confirmOverwriteTitle: 'Potwierdź zastąpienie istniejących danych',
	confirmOverwriteMsg: 'Plik \'%{nameOfFile}\' już istnieje. Czy chcesz zastąpić dane danymi zawartymi w wybranym pliku?',

	// copy move dialog
	copy: 'Kopiuj',
	move: 'Przesuń',
	copyOrMove: 'Kopiuj lub przenieś: ',
	copyOnly: 'Kopiuj ',
	createShortcut: 'Utwórz skrót',
	createShortcutDialogTitle: 'Utwórz skrót: ',

	// External asset types
	wsProject: 'Projekt Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pakiet',
	dataModule: 'Moduł danych',
	exploration: 'Eksploracja',
	mode: 'Tryb',
	live: 'Na żywo',
	snapshot: 'Obraz stanu',
	noSnapshotsFound: 'Nie znaleziono obrazu stanu',
	uploadedFile: 'Przesłany plik',
	fileUpload: 'Prześlij dane',
	dataSetEx: 'Zestaw danych',
	externalRepository: 'Repozytorium zewnętrzne',
	queryMode: 'Tryb zapytań',
	queryModeCompatible: 'Zgodne',
	queryModeDynamic: 'Dynamiczne',
	report: 'Raport',
	activeReport: 'Aktywny raport',
	query: 'Zapytanie',
	analysis: 'Analiza',
	dashboard: 'Kokpit',
	dashboardTemplate: 'Szablon kokpitu',
	jupyterNotebook: 'Notatnik',
	wsNotebook: 'Notatnik Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Scenariusz',
	workspace: 'Obszar roboczy',
	pagelet: 'Strona',
	content: 'Treść',
	directory: 'Przestrzenie nazw',
	dataSet: 'Zestaw danych',
	powerPlayCube: 'Kostka PowerPlay',
	powerPlayReport: 'Raport PowerPlay',
	powerPlay8Report: 'Raport PowerPlay',
	powerPlay8ReportView: 'Widok raportu PowerPlay',
	reportTemplate: 'Szablon raportu',
	packageConfigurations: 'Konfiguracja pakietu',
	agent: 'Agent',
	agentDefinition: 'Definicja agenta',
	agentDefinitionView: 'Widok agenta',
	dataMovementTask: 'Zadanie przenoszenia danych',
	dataMovementTaskAlias: 'Alias zadania przenoszenia danych',
	document: 'Dokument',
	DocumentRetention: 'Właściwości dokumentu',
	jobDefinition: 'Definicja zadania',
	job: 'Zadanie',
	metricsDataSourceETLTask: 'Zadanie ETL źródła danych metryk',
	metricsExportTask: 'Zadanie eksportu metryk',
	metricsFileImportTask: 'Zadanie importu pliku metryk',
	metricsMaintenanceTask: 'Zadanie obsługi metryk',
	planningTask: 'Zadanie planowania',
	shortcut: 'Skrót',
	URL: 'Adres URL',
	launchable: 'Z możliwością uruchamiania',
	dataSetFolder: 'Folder zestawu danych',
	ViewAccessibleLabel: 'Widok %{label}',
	overrideReportOptions: 'Przesłoń domyślne opcje raportu',
	formats: 'Formaty',
	saveReport: 'Zapisz raport',
	promptForValues: 'Pytaj mnie',
	reportView: 'Widok raportu',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Dane programu Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Szczegóły',
	open: 'Otwórz',
	created: 'Utworzone',
	modified: 'Zmodyfikowano',
	owner: 'Właściciel',
	dataSource: 'Źródło danych',
	share: 'Udostępnij',
	addToFavorites: 'Dodaj do ulubionych',
	properties: 'Właściwości',
	detailsEmptyStateBody: 'Wybierz element, aby wyświetlić jego szczegóły',
	editNameAndDescription: 'Edytuj nazwę i opis',
	none: 'Brak',

	//rename dialog
	nameInvalid: 'Nazwa jest niepoprawna',
	namePlaceholder: 'Wprowadź nazwę',
	description: 'Opis',
	descriptionInvalid: 'Długość opisu nie może przekraczać 350 znaków.',
	descriptionPlaceholder: 'Wprowadź opis',
	errorMessageApostropheError: 'Wprowadź nazwę pliku, która nie zawiera znaków \' ani "',
	renameCollisionError: '%{name} już istnieje. Spróbuj użyć innej nazwy.',
	unknownRenameError: 'Zmiana nazwy elementu nie powiodła się. Skontaktuj się z administratorem, aby uzyskać dalszą pomoc.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Nie można otworzyć wskazanego folderu.',

	//Upload
	uploadToFolder: "Prześlij do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Prześlij do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> i uruchom%{launchAction}",
	quickUpload: "Szybkie przesyłanie",
	quickUploadAndLaunch: "Przeciągnij i upuść pliki, które mają zostać przesłane do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>, i otwórz je w jednym z następujących obszarów.",
	unsupportedFilesSingle: "Plik %{files} nie został przesłany, ponieważ nie jest obsługiwany przez funkcję szybkiego przesyłania.",
	unsupportedFilesMultiple: "Pliki nie zostały przesłane, ponieważ wszystkie wybrane pliki muszą nadawać się do szybkiego uruchamiania.",
	unsupportedFilesSingleInvalid: "Plik %{files} jest niepoprawny.",
	unsupportedFilesMultipleInvalid: "Pliki %{files} są niepoprawne.",
	supportedFileTypes: "Dozwolone są tylko następujące typy plików: %{extensions}.",
	uploadDragAndDrop: "Przeciągnij i upuść",
	uploadDragAndDropMessage: "Przeciągnij i upuść plik w tym miejscu, aby przesłać go do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Kryteria wyszukiwania \'%{searchTerm}\' zostały zapisane.',
	searchWasntSaved: 'Kryteria wyszukiwania \'%{searchTerm}\' nie zostały zapisane.',
	searchSuggestions: 'Sugestie',
	savedSearch: 'Zapisane wyszukiwania',
	searchWasDeleted: 'Kryteria wyszukiwania \'%{searchTerm}\' zostały usunięte.',
	searchWasntDeleted: 'Kryteria wyszukiwania \'%{searchTerm}\' nie zostały usunięte.',
	savedBarTitle: 'Szukaj w Cognos Analytics',
	searchContentPageTitle: 'Szukaj',
	searchContentPageTitleLabel: 'Wyświetlanie wyników dla \'%{searchTerm}\'',
	showingSearchRsult: 'Wyświetlanie %{resultCount} elementów',
	saveSearch: 'Zapisz wyszukiwanie',
	saveTenSearches: 'Można zapisać 10 wyszukiwań.',
	deleteASearch: 'Usuń jedno, aby zapisać nowe.',
	close: 'Zamknij',

	//recent view
	recents: 'Ostatnie',
	noAccessRecent: 'Brak dostępu',
	noAccessRecentMsg: 'Nie masz dostępu do tego zasobu. Możliwe, że został wyłączony lub usunięty albo uprawnienia użytkownika zostały ograniczone. Sprawdź stan zasobu w jego oczekiwanym położeniu źródłowym. Można usunąć zasób z listy ostatnio używanych elementów, klikając przycisk OK.',
	noAccessMsg: 'Nie masz dostępu do tego zasobu. Możliwe, że został wyłączony lub usunięty albo uprawnienia użytkownika zostały ograniczone.',

	//contextToolbar
	itemsSelected: 'Wybrano elementów: %{nameOfSelection}',
	itemSelected: 'Wybrano %{nameOfSelection} element'

});